"use client";

import React, { ReactNode } from "react";
import { useIsMobile } from "@/src/blocks/converters";

export const PageContainer = ({ img, children }: { img?: string; children: ReactNode }) => {
    const isMobile = useIsMobile();

    return (
        <div
            className={`flex justify-center relative bg-cover bg-center overflow-hidden ${isMobile ? "" : "p-4 pr-8 pl-8"} shrink-0`}
            // without a splash, url(undefined) would request /undefined
            style={img ? { backgroundImage: `url(${img})` } : {}}
        >
            <div className="absolute inset-0 backdrop-blur-2xl bg-white/1"></div>
            <div className="absolute inset-0 bg-linear-to-b from-black/50 via-black/70 to-[#141414]"></div>
            {children}
        </div>
    );
};

export const SheetContainer = ({ img, inSheet, children }: { img?: string; inSheet: boolean; children: ReactNode }) => (
    <div
        className="flex flex-col h-full bg-center bg-cover overflow-scroll bg-transparent"
        style={inSheet && img ? { backgroundImage: `url(${img})` } : {}}
    >
        {/*header*/}
        {inSheet && (
            <>
                <div className="absolute inset-0 backdrop-blur-2xl bg-white/1"></div>
                <div className="absolute inset-0 bg-linear-to-b from-black/50 via-black/70 to-[#141414]"></div>
            </>
        )}
        {children}
    </div>
);
